// Export typed configuration object
interface Config {
  api: {
    baseUrl: string;
    credentials: 'include' | 'same-origin' | 'omit';
  };
  cognito: {
    clientId: string;
    region: string;
  };
  media: {
    host: string;
    cdnUrl: string;
  };
}

const config: Config = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE!,
    credentials: 'include',
  },
  cognito: {
    clientId: process.env.REACT_APP_CLIENT_ID!,
    region: 'eu-central-1',
  },
  media: {
    host: process.env.REACT_APP_HOST!,
    cdnUrl: `https://media.${process.env.REACT_APP_HOST}`,
  },
};

export default config;
